module.exports = __webpack_public_path__ + "img/qr_box_black.dd373fef.svg";